// extracted by mini-css-extract-plugin
module.exports = {"productWidgetApp":"-M081","horizontal":"_8Luqx","emptyState":"_1-Q7E"};